// extracted by mini-css-extract-plugin
module.exports = {"comment":"popupactmvp_comment__3xFZu"};